/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import { Formik } from 'formik';
import i18n from 'i18n';
import { newCloneClientRequest } from 'modules/clients/actions';
import React from 'react';
import { connect } from 'react-redux';
import GenericForm from 'skyone-lib/lib/GenericForm';
import ApplicationState from 'store/interfaces';
import { CloneClientProps } from 'modules/clients/interfaces';
import Button from 'components/Button';
import {
  CompanyData,
  PartnerData,
  PermissionsData,
} from 'modules/authenticate/interfaces';
import validationSchema from './schema';
import styles from './styles';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

const initialValues: CloneClientProps = {
  name: '',
};

interface Props {
  clientCopyName: string;
  clientUuid: string;
  companySelected: CompanyData | null;
  partnerSelected: PartnerData | null;
  permissions?: PermissionsData;
  newCloneClientRequest: (props) => void;
  onCancel: () => void;
  onCloseModal: () => void;
}

const FormCloneClient = ({
  clientCopyName,
  clientUuid,
  companySelected,
  partnerSelected,
  permissions,
  newCloneClientRequest,
  onCancel,
  onCloseModal,
}: Props) => {
  const classes = useStyles();
  const [query] = React.useState(initialQuery);

  const handleSubmit = values => {
    newCloneClientRequest({
      values,
      clientUuid,
      query: {
        ...query,
        company_uuid: permissions?.can_view_all_resources
          ? ''
          : companySelected?.id,
        partner_uuid: permissions?.can_view_all_resources
          ? ''
          : partnerSelected?.id,
      },
    });
    onCloseModal();
  };

  return (
    <Grid item container>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ setFieldValue, submitForm, errors, values }) => (
          <Grid container spacing={2} className={classes.cloneClient}>
            <GenericForm
              fields={values}
              screenFields={[
                {
                  gridXs: 12,
                  label: i18n.t('CLIENTS_PAGE.NEW_CLONE_CLIENT_KEY'),
                  stateKey: 'name',
                  placeholder: `${i18n.t('COPY_KEY')} - ${clientCopyName}`,
                },
              ]}
              setFieldValue={setFieldValue}
              errors={errors}
            />
            <Grid container justify="flex-end" className={classes.buttonsBase}>
              <Grid container className={classes.buttonsAlign}>
                <Button
                  id="submit-button"
                  submitButton
                  onClick={submitForm}
                  disabled={false}
                >
                  {i18n.t('CLONE_KEY')}
                </Button>
                <Button
                  id="cancel-button"
                  variant="outlined"
                  onClick={onCancel}
                >
                  {i18n.t('CANCEL_KEY')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data, partnerSelected },
  clients: { clientList },
}: ApplicationState) => ({
  clientList,
  companySelected,
  partnerSelected,
  permissions: data?.permissions,
});

export default connect(mapStateToProps, {
  newCloneClientRequest,
})(FormCloneClient);
